import type { SbLinkFromSchema, ShopifyLinkFromSchema } from "~/components/ui/Link/_data/schema"

export function isSbLink(link: SbLinkFromSchema | ShopifyLinkFromSchema): link is SbLinkFromSchema {
  return "linktype" in link && link.linktype === "story"
}

export function isShopifyLink(link: SbLinkFromSchema | ShopifyLinkFromSchema): link is ShopifyLinkFromSchema {
  return "handle" in link
}
